import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { IconList } from './IconList.js';
var _excluded = ["icon", "dataProp", "fontSize", "className", "sx"];
var iconSizes = {
  small: '16px',
  medium: '20px',
  large: '24px'
};

var useStyles = function useStyles(iconSize) {
  return {
    iconStyle: {
      height: iconSize,
      width: iconSize,
      // ie11 only
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        pointerEvents: 'none'
      }
    }
  };
};

var Icon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var icon = props.icon,
      _props$dataProp = props.dataProp,
      dataProp = _props$dataProp === void 0 ? icon : _props$dataProp,
      fontSize = props.fontSize,
      className = props.className,
      sx = props.sx,
      rest = _objectWithoutProperties(props, _excluded);

  var iconSize = iconSizes[fontSize || 'medium'];

  var _useStyles = useStyles(iconSize),
      iconStyle = _useStyles.iconStyle;

  var IconComponent = IconList[icon];
  /* istanbul ignore next */

  if (process.env.NODE_ENV !== 'production') {
    if (!IconComponent) {
      console.warn("The icon ".concat(icon, " is not valid. If you would like to use this icon, make sure to add it to the @archer/ui-components library."));
    }
  }

  return IconComponent ? /*#__PURE__*/React.createElement(IconComponent, _extends({
    ref: ref
  }, rest, {
    sx: [iconStyle, sx],
    className: className,
    "data-selector": dataProp
  })) : null;
});
Icon.displayName = 'Icon';
export { Icon };